import { CreateUnavailability } from '@services';
import { useStore } from '@stores';
import { Form } from 'antd';
import dayjs from 'dayjs';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import Presentation from './UnavailabilityDrawer.presentation';

interface IProps {
  name?: string;
  userId?: number;
  workStationId?: string;
  setClose: () => void;
}

export const UnavailabilityDrawer: React.FC<IProps> = observer(
  ({ name, userId, workStationId, setClose }) => {
    const { unavailabilityStore } = useStore();
    const [form] = Form.useForm();

    useEffect(() => {
      form.setFieldsValue({ userId, workStationId });
    }, [form, userId, workStationId]);

    const handleSubmit = async (values: CreateUnavailability) => {
      await unavailabilityStore.create({
        ...values,
        startAt: dayjs(values.startAt).format(),
        endAt: dayjs(values.endAt).format(),
      });
      form.resetFields();
    };

    return (
      <Presentation
        form={form}
        name={name}
        userId={userId}
        workStationId={workStationId}
        setClose={setClose}
        handleSubmit={handleSubmit}
      />
    );
  }
);
